// extracted by mini-css-extract-plugin
var _1 = "EmailGoogleTemplateWrapper-modulepdfViewer__NvDLL";
var _2 = "EmailGoogleTemplateWrapper-modulepreview__tFVGj";
var _3 = "EmailGoogleTemplateWrapper-moduletemplate__b8EIT";
var _4 = "EmailGoogleTemplateWrapper-modulevariablesSection__LiHF3";
export { _1 as "pdfViewer", _2 as "preview", _3 as "template", _4 as "variablesSection" }
